import { render, staticRenderFns } from "./goldCoinDown.vue?vue&type=template&id=406211a6&scoped=true&"
import script from "./goldCoinDown.vue?vue&type=script&lang=js&"
export * from "./goldCoinDown.vue?vue&type=script&lang=js&"
import style0 from "./goldCoinDown.vue?vue&type=style&index=0&id=406211a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406211a6",
  null
  
)

export default component.exports